import ChallengeProgressionBarComponent from "./ChallengeProgressionBarComponent";

export default ChallengeProgressionBarComponent;